var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gwnl-position-eval__info pb40" },
    [
      _c(
        "yxt-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "form",
          attrs: {
            rules: _vm.rules,
            model: _vm.form,
            "label-width": "100px",
            "label-position": "top",
            "is-need-require": "",
          },
        },
        [
          _c("yxt-blockhead", {
            attrs: {
              title: _vm.$t("pc_base_info"),
              size: "small",
              type: "special",
            },
          }),
          _c(
            "div",
            { staticClass: "ml16 mt8" },
            [
              _c(
                "yxt-form-item",
                {
                  attrs: {
                    label: _vm.$t("pc_gwnl_global_lbl_projectName"),
                    prop: "name",
                  },
                },
                [
                  _c("yxt-input", {
                    attrs: {
                      maxlength: "50",
                      placeholder: _vm.$t("pc_gwnl_global_enterProjectName"),
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _vm.showInfo
                ? _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm
                          .$t("pc_eval_lbl_project_owner")
                          .d("项目负责人"),
                        prop: "owners",
                      },
                    },
                    [
                      _c("yxt-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          multiple: "",
                          placeholder: _vm
                            .$t("pc_gwnl_global_please_selected")
                            .d("请选择"),
                          "icon-name": "more",
                          "hidden-option": "",
                          "collapse-tags": "",
                          "value-key": "id",
                          "prop-label": "fullname",
                          clearable: "",
                        },
                        on: { "visible-change": _vm.handleOpenOwner },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "tag",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(data.currentLabel)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2668518610
                        ),
                        model: {
                          value: _vm.form.owners,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "owners", $$v)
                          },
                          expression: "form.owners",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isBehavior
                ? _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        prop: "targetId",
                        label: _vm.$t("pc_gwnl_eval_evalTools"),
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.selectedUtil && _vm.selectedUtil.surveyName
                          )
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.isPerson &&
              _vm.selectedUtil.packageType !== _vm.EnumPackageType.beizhi
                ? _c(
                    "yxt-form-item",
                    {
                      attrs: {
                        label: _vm.$t("pc_gwnl_eval_lbl_evalNorm"),
                        prop: "modelId",
                      },
                    },
                    [
                      _c(
                        "yxt-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("pc_gwnl_global_pleaseSelect"),
                          },
                          on: { change: _vm.changeNorms },
                          model: {
                            value: _vm.form.modelId,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "modelId", $$v)
                            },
                            expression: "form.modelId",
                          },
                        },
                        _vm._l(_vm.selectedUtil.normList, function (norm) {
                          return _c("yxt-option", {
                            key: norm.normId,
                            attrs: { label: norm.normName, value: norm.normId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "yxt-form-item",
                {
                  attrs: {
                    label: _vm.$t("pc_gwnl_eval_lbl_evalTime"),
                    prop: "time",
                  },
                },
                [
                  _c("yxt-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                      type: "datetimerange",
                      "range-separator": _vm.$t("pc_gwnl_eval_to"),
                      "start-placeholder": _vm.$t(
                        "pc_gwnl_global_startDateTime"
                      ),
                      "end-placeholder": _vm.$t("pc_gwnl_global_endDateTime"),
                      "picker-options": _vm.pickerOptions,
                    },
                    model: {
                      value: _vm.form.time,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "time", $$v)
                      },
                      expression: "form.time",
                    },
                  }),
                ],
                1
              ),
              _c(
                "yxt-form-item",
                {
                  attrs: {
                    label: _vm.$t("pc_gwnl_web_lbl_survey_information_hint"),
                    prop: "description",
                  },
                },
                [
                  _c("yxt-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "200",
                      placeholder:
                        _vm.$t("pc_gwnl_web_pleaseEnter") +
                        _vm.$t("pc_gwnl_web_lbl_survey_information_hint"),
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.peerAssess || _vm.isBehavior
            ? [
                _c("yxt-blockhead", {
                  staticClass: "mt32 mb8",
                  attrs: {
                    title: _vm.$t("pc_gwnl_eval_evalSettings").d("评估设置"),
                    size: "small",
                    type: "special",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "ml16" },
                  [
                    _c(
                      "yxt-form-item",
                      {
                        attrs: {
                          label: _vm.$t("pc_gwnl_eval_evalRelationship"),
                          required: "",
                          prop: "evaluationConfig4Create",
                        },
                      },
                      [
                        _vm.showInfo
                          ? _c(
                              "div",
                              {
                                staticClass: "flex-col flex",
                                class: {
                                  "eval-custom-checkbox":
                                    !_vm.expend && _vm.isBehavior,
                                },
                              },
                              _vm._l(_vm.dimensionInfo, function (item) {
                                return _c(
                                  "div",
                                  { key: item.type },
                                  [
                                    item.type !== "2"
                                      ? _c(
                                          "yxt-checkbox",
                                          {
                                            attrs: {
                                              "true-label": 1,
                                              "false-label": 0,
                                              disabled:
                                                _vm.disabledRelationBox(item),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeEnable(
                                                  _vm.form
                                                    .evaluationConfig4Create[
                                                    item.prop
                                                  ],
                                                  item.type
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.form
                                                  .evaluationConfig4Create[
                                                  item.prop
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.form
                                                    .evaluationConfig4Create,
                                                  item.prop,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "form.evaluationConfig4Create[item.prop]",
                                            },
                                          },
                                          [
                                            _c("eval-tooltip", {
                                              attrs: {
                                                label: item.label,
                                                disabledFunc:
                                                  _vm.disabledRelationBox(item),
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : [
                                          _c(
                                            "yxt-checkbox",
                                            {
                                              attrs: {
                                                "true-label": 1,
                                                "false-label": 0,
                                                disabled:
                                                  _vm.disabledRelationBox(item),
                                              },
                                              on: {
                                                change: _vm.changeLeaderEnable,
                                              },
                                              model: {
                                                value:
                                                  _vm.form
                                                    .evaluationConfig4Create
                                                    .enabledLeader,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form
                                                      .evaluationConfig4Create,
                                                    "enabledLeader",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.evaluationConfig4Create.enabledLeader",
                                              },
                                            },
                                            [
                                              _c("eval-tooltip", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "pc_gwnl_global_leaderAssessment"
                                                  ),
                                                  disabledFunc:
                                                    _vm.disabledRelationBox(
                                                      item
                                                    ),
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm.form.evaluationConfig4Create
                                            .enabledLeader === 1
                                            ? [
                                                _c(
                                                  "yxt-radio",
                                                  {
                                                    attrs: {
                                                      label: "enabledLeaderPm",
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.changeLeaderType,
                                                    },
                                                    model: {
                                                      value: _vm.leaderType,
                                                      callback: function ($$v) {
                                                        _vm.leaderType = $$v
                                                      },
                                                      expression: "leaderType",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pc_gwnl_eval_departmentManager"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "yxt-radio",
                                                  {
                                                    attrs: {
                                                      label: "enabledLeaderDm",
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.changeLeaderType,
                                                    },
                                                    model: {
                                                      value: _vm.leaderType,
                                                      callback: function ($$v) {
                                                        _vm.leaderType = $$v
                                                      },
                                                      expression: "leaderType",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pc_gwnl_eval_directManager"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                  ],
                                  2
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm.isBehavior &&
                        _vm.dimensionInfo &&
                        _vm.dimensionInfo.length > 6
                          ? _c(
                              "div",
                              {
                                staticClass: "eval-custom-text hand",
                                on: {
                                  click: function ($event) {
                                    _vm.expend = !_vm.expend
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "color-primary-6" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.expend
                                        ? _vm.$t(
                                            "pc_gwnl_clamp_retract" /* 收起 */
                                          )
                                        : _vm.$t(
                                            "pc_comp_sideBar_open" /* 展开 */
                                          )
                                    )
                                  ),
                                ]),
                                _c("yxt-svg", {
                                  staticClass: "color-primary-6 ml2",
                                  attrs: {
                                    width: "16px",
                                    height: "16px",
                                    "icon-class": _vm.expend
                                      ? "arrow_down"
                                      : "arrow_up",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm.weightList && _vm.weightList.length > 1
                      ? [
                          _c(
                            "yxt-form-item",
                            {
                              attrs: {
                                label: _vm.$t("pc_gwnl_eval_lbl_evalWeight"),
                                prop: "weight",
                                required: "",
                                "label-tooltip": _vm.$t(
                                  "pc_gwnl_eval_weightSettingTooltip"
                                ),
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "flex flex-col" },
                                [
                                  _c(
                                    "yxt-radio",
                                    {
                                      staticClass: "mt8",
                                      attrs: { label: 1 },
                                      on: { change: _vm.setAverageWeight },
                                      model: {
                                        value:
                                          _vm.form.evaluationConfig4Create
                                            .weightType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.form.evaluationConfig4Create,
                                            "weightType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.evaluationConfig4Create.weightType",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("pc_gwnl_eval_averageWeight")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "mt8" },
                                    [
                                      _c(
                                        "yxt-radio",
                                        {
                                          attrs: { label: 2 },
                                          on: { change: _vm.setAverageWeight },
                                          model: {
                                            value:
                                              _vm.form.evaluationConfig4Create
                                                .weightType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form
                                                  .evaluationConfig4Create,
                                                "weightType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "form.evaluationConfig4Create.weightType",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_gwnl_eval_customWeight"
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      parseInt(
                                        _vm.form.evaluationConfig4Create
                                          .weightType
                                      ) === 2
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "flex flex-wrap mt12 bg-lightgrey pl16 pt16 pb8 yxtbizf-br-4",
                                            },
                                            _vm._l(
                                              _vm.weightList,
                                              function (item) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: item.weight,
                                                    staticClass:
                                                      "flex weight-item mb8",
                                                  },
                                                  [
                                                    _c(
                                                      "yxt-tooltip",
                                                      {
                                                        attrs: {
                                                          content: item.label,
                                                          placement: "top",
                                                          "open-filter": "",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "mr8 ellipsis",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.label)
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c("yxt-input-number", {
                                                      staticClass:
                                                        "yxtbiz-flex-shrink-0",
                                                      attrs: {
                                                        precision: 0,
                                                        min: 0,
                                                        max: 100,
                                                        formatter:
                                                          _vm.handleFormatter,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.weight[
                                                            item.weight
                                                          ],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.weight,
                                                            item.weight,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "weight[item.weight]",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "yxt-form-item",
                            {
                              attrs: {
                                label: _vm
                                  .$t("pc_talent_lbl_other_eval_rule")
                                  .d("他评分计算规则"),
                                prop: "evaluationConfig4Create.othersWeightType",
                                required: "",
                              },
                            },
                            [
                              _c(
                                "yxt-radio-group",
                                {
                                  model: {
                                    value:
                                      _vm.form.evaluationConfig4Create
                                        .othersWeightType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form.evaluationConfig4Create,
                                        "othersWeightType",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.evaluationConfig4Create.othersWeightType",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "yxt-radio",
                                        { attrs: { label: 0 } },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t(
                                                  "pc_talent_msg_use_weight" /* 权重计算 */
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                          _c(
                                            "yxt-tooltip",
                                            {
                                              staticClass: "v-middle",
                                              attrs: {
                                                content: _vm.$t(
                                                  "pc_talent_tips_eval_use_weight"
                                                ),
                                                placement: "top",
                                                "max-width": 400,
                                              },
                                            },
                                            [
                                              _c("yxt-svg", {
                                                staticClass:
                                                  "color-gray-6 pb2 hover-primary-6 hand v-mid ml5",
                                                attrs: {
                                                  width: "16px",
                                                  height: "16px",
                                                  "icon-class":
                                                    "question-cirlce-o",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "mt16" }, [
                                    _c(
                                      "div",
                                      { staticClass: "eval-self-weight-left" },
                                      [
                                        _c(
                                          "yxt-radio",
                                          { attrs: { label: 1 } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "pc_talent_msg_eval_not_use_weight" /* 非权重计算 */
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                            _c(
                                              "yxt-tooltip",
                                              {
                                                attrs: {
                                                  content: _vm.$t(
                                                    "pc_talent_tips_eval_not_use_weight"
                                                  ),
                                                  placement: "top",
                                                  "max-width": 400,
                                                },
                                              },
                                              [
                                                _c("yxt-svg", {
                                                  staticClass:
                                                    "color-gray-6 hover-primary-6 pb2 hand v-mid ml5",
                                                  attrs: {
                                                    width: "16px",
                                                    height: "16px",
                                                    "icon-class":
                                                      "question-cirlce-o",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm.type === 4
                      ? _c(
                          "yxt-form-item",
                          {
                            attrs: {
                              size: "small",
                              label: _vm
                                .$t("pc_talent_lbl_eval_content")
                                .d("评估内容"),
                            },
                          },
                          [
                            _c("yxt-switch", {
                              attrs: { "active-value": 1, "inactive-value": 0 },
                              model: {
                                value: _vm.form.isImport,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "isImport", $$v)
                                },
                                expression: "form.isImport",
                              },
                            }),
                            _c("span", { staticClass: "ml4" }, [
                              _vm._v(
                                _vm._s(
                                  _vm
                                    .$t("pc_talent_msg_enable_eval_data_import")
                                    .d("支持初始化数据导入")
                                )
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            : _vm._e(),
          _c(
            "div",
            { staticClass: "ml16" },
            [
              _c(
                "yxt-form-item",
                {
                  attrs: {
                    label: _vm.$t("pc_gwnl_global_remarks"),
                    prop: "remark",
                  },
                },
                [
                  _c("yxt-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      maxlength: "200",
                      placeholder: _vm.$t("pc_gwnl_eval_enterRemark"),
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
              !_vm.isBehavior
                ? _c(
                    "yxt-form-item",
                    { staticClass: "eval-remark1" },
                    [
                      _c(
                        "yxt-checkbox",
                        {
                          attrs: { "true-label": 1, "false-label": 0 },
                          on: { change: _vm.msgTypeChange },
                          model: {
                            value: _vm.form.autoIssueReport,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "autoIssueReport", $$v)
                            },
                            expression: "form.autoIssueReport",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("pc_eval_eval_seting_tips")) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c("yxtbiz-eval-step-footer", {
        attrs: { operation: _vm.operation, "footer-width": "960px" },
      }),
      _c("yxtbiz-eval-select-user", {
        ref: "userselector",
        attrs: {
          "function-code": _vm.functionCode,
          "data-permission-code": _vm.dataPermissionCode,
          data: _vm.form.owners,
          visible: _vm.selectUserVisible,
          tabs: ["persons", "userGroup", "advance"],
          limit: 1000,
        },
        on: {
          "update:visible": function ($event) {
            _vm.selectUserVisible = $event
          },
          getUsers: _vm.getUsers,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }